import styled from 'styled-components';

export const Input = styled.input`
  &&&&& {
    -webkit-appearance: none;
    border: none;
    padding: ${(props) =>
        props.labelHeight ? `${props.labelHeight + 10}px` : '1.5em'}
      0.5em 0.5em;
    width: 100%;
    border-bottom: 4px solid ${(props) => props.borderColor};
    outline: none;
    font-size: 1.25em;
    z-index: 1;
    background: transparent;
    transition: all 0.125s ease-in-out;
    :invalid {
      border-color: ${(props) =>
        !!props.value ? props.invalidColor : props.borderColor};
    }
    :invalid + span {
      color: ${(props) =>
        !!props.value
          ? props.invalidColor
          : props.active
          ? props.activeColor
          : '#797979'};
    }
    margin-bottom: 0;
  }
`;

export const InputLabel = styled.label`
  position: absolute;
  top: 0.5rem;
  left: 0.65rem;

  font-weight: ${(props) => (props.active ? '400' : '300')};
  font-size: ${(props) => (props.active ? '.75em' : '1.25em')};
  transform: translateY(${(props) => (props.active ? '0' : '.75rem')});
  transition: all 0.125s ease-in-out;
  color: ${(props) => (props.active ? props.activeColor : '#797979')};
  will-change: color, font-weight, transform, font-size;
  z-index: 0;
`;

export const InputWrapper = styled.div`
  position: relative;
  background: #f5f5f2;
`;
